import axios from 'axios';
import { StatusCodes } from 'http-status-codes';
import { ErrorProvider } from '../../../libraries/branch-tooling-next/Error/ErrorProvider';

import { UNAVAILABLE_SOURCE_DASHBOARD } from '../../../../shared/constants';
import { ORG_VIEW, AGENCY_VIEW, APP_VIEW_ID_FIELD, ORG_VIEW_ID_FIELD } from '../../common/support/viewConstants';
import { openLogoutModal } from '../actions/LogoutModalActions';

const { view } = window.App.context;
const sendOrgIdHeader = view && (view.current_view === ORG_VIEW || view.current_view === AGENCY_VIEW);

axios.defaults.headers.common = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'X-Branch-Dashboard': 'dashboard',
  'x-csrf-token': window._csrfToken,
  'X-Client-Redirect': 'dashboard',
};

let headers = { ...axios.defaults.headers.common };
if (view) {
  headers = {
    ...headers,
    ...(sendOrgIdHeader ? { 'x-organization-id': view[ORG_VIEW_ID_FIELD] } : { 'x-app-id': view[APP_VIEW_ID_FIELD] }),
  };
}

const dash_api = axios.create({
  headers,
  transformRequest: [...axios.defaults.transformRequest],
  transformResponse: [...axios.defaults.transformResponse],
  withCredentials: true,
});

dash_api.interceptors.response.use(
  (resp) => resp,
  async (error) => {
    const errorProvider = new ErrorProvider().parse(error);
    const status = errorProvider.getStatus();
    const response = errorProvider.getResponse();
    if (status === StatusCodes.IM_A_TEAPOT && response?.data?.source === UNAVAILABLE_SOURCE_DASHBOARD) {
      return location.reload();
    }
    throw error;
  }
);

export const dashApiInterceptorSetup = (store) => {
  // Adds a response interceptor when we initialize redux store
  dash_api.interceptors.response.use(
    (resp) => {
      if (resp.data && resp.data['X-Client-Redirect']) {
        store.dispatch(openLogoutModal());
      }
      return resp;
    },
    async (error) => {
      const errorProvider = new ErrorProvider().parse(error);
      const status = errorProvider.getStatus();

      if (status === 401) {
        await store.dispatch(openLogoutModal());
      }
      throw error;
    }
  );
};

export default dash_api;
